export const isInViewport = (offset = 0, element: HTMLDivElement | null) => {
  if (!element) {
    return false;
  }

  const top = element.getBoundingClientRect().top;

  return top + offset >= 0 && top - offset <= window.innerHeight;
};
